/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {useRef} from "react";

import Objects from 'toolbox/objects';

export function useCompare(selector) {
    const prev = useRef(undefined)
    return (state) => {
        const next = selector(state)
        if (Objects.areEqual(prev.current, next)) {
            return prev.current
        } else {
            prev.current = next
            return next
        }
    }
}